import Vue from 'vue'
import Vuex from 'vuex'

import diet from './modules/diet'
import getters from './getters'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    diet
  },
  getters
})
